import React from 'react';

function TestAuthSuccess() {
  return (
    <div>
      <h2>Authentication Successful!</h2>
      <p>You have been redirected to this test page after successful validation.</p>
    </div>
  );
}

export default TestAuthSuccess;